import { ChangeDetectionStrategy, Component, EventEmitter, Output, inject } from '@angular/core'

import {
  FLX_MODAL_DATA,
  FlxButtonModule,
  FlxModalModule,
  FlxModalService,
} from '@flowx/angular-ui-toolkit'
import { DataModelResourceType } from '@flowx/designer/shared/api/data-model.api'

import {
  DataModelEntity,
  EntityDataModelPathReferences,
} from '../../../core/dictionary/data-model.dictionary'
import { EntityReferencesComponent } from '../entity-references/entity-references.component'

@Component({
  selector: 'flx-delete-entity-confirmation-modal',
  imports: [FlxModalModule, EntityReferencesComponent, FlxButtonModule],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './delete-entity-confirmation-modal.component.html',
})
export class DeleteEntityConfirmationModalComponent {
  readonly #modalService = inject(FlxModalService)
  @Output() dataEventEmitter = new EventEmitter<{ entity: DataModelEntity }>()

  readonly data = inject<{
    entity: DataModelEntity
    references: EntityDataModelPathReferences[]
    resourceType: DataModelResourceType
  }>(FLX_MODAL_DATA)

  closeModal(): void {
    this.#modalService.hide()
  }

  confirm(): void {
    this.dataEventEmitter.emit({ entity: this.data.entity })
  }
}
